import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, timer } from 'rxjs';
import { filter, first, takeUntil, finalize, map, tap } from 'rxjs/operators';
import * as uuid from 'uuid';

@Injectable({
	providedIn: 'root',
})
export class ToastService {

	public toastQueue$: BehaviorSubject<Array<any>> = new BehaviorSubject<any>([]);
	private executing = false;
	private notificationDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(0);
	private executing$: Subject<void> = new Subject();
	private currentValue = null;
	constructor() { this.create(); }

	private create() {

		this.toastQueue$.subscribe(async () => {
			if (this.executing) {
				if (this.currentValue?.data?.options?.autoDismiss === true) {
					this.notify({ id: this.currentValue.id,data:false });
				}
				return;
			}

			let toastQueryArray = this.toastQueue$.getValue();
			if (toastQueryArray.length > 0) {
				this.currentValue = { ...toastQueryArray[0] };
				this.executing = true;
				timer(this.currentValue.data.options.duration).pipe(takeUntil(this.executing$), finalize(() => {
					toastQueryArray = this.toastQueue$.getValue();
					let value = toastQueryArray.shift();
					this.executing = false;
					this.currentValue = null;
					this.notify({ id: value.id,data:false });
					this.toastQueue$.next(toastQueryArray);
				})).subscribe();
			}
		})
	}

	public toast(message: string,  options?: {
		buttonLabel?: string,
		duration?: number;
		autoDismiss?: boolean,
		data?: any
	}): Promise<any> {
		if (!options) {
			options = {};
		}
		if (!options.duration) {
			options.duration = 3000;
		}
		if (!options.autoDismiss) {
			options.autoDismiss = false;
		}

		const data = { message, options }
		const id = uuid.v4();
		this.toastQueue$.next([...this.toastQueue$.value, { data, id }]);
		return this.notificationDataSubject.pipe(filter(value => value.id === id),first(),map(value => value.data)).toPromise();
	}

	public notify(toast: any) {
		this.notificationDataSubject.next(toast);
		this.executing$.next();
	}
}
